<template lang="html">
<div class="sidebar">
  <div class="sidebar-desktop">
    <img 
    class="sidebar-desktop-logo" 
    src="@/assets/img/client-logo.png"/>
    <div class="sidebar-desktop-links">
      <a
      class="sidebar-desktop-link"
      v-for="item in menuItems" 
      :href="item.url" 
      :key="item.index"
      v-scroll-to="item.url">
        {{ item.title }}
      </a>
    </div>
  </div>
  <div class="sidebar-mobile">
    <div class="">
      <a
      class="sidebar-mobile-link"
      v-for="item in menuItems" 
      :href="item.url" 
      :key="item.index"
      v-scroll-to="item.url">
        {{ item.title }}
      </a>
    </div>
  </div>
</div>
</template>

<script>

export default {
  components: {
  },
	data: () => {
		return {
			menuItems: [
        {
          title: 'Case Study',
          url: '#casestudy'
        },
        {
          title: 'Top Performers',
          url: '#performers'
        },
        {
          title: 'National Pizza Day',
          url: '#pizzaday'
        },
        {
          title: 'Results',
          url: '#results'
        },
					]
			}
	}
}
</script>

<style scoped lang="scss">
.sidebar {
  &-desktop {
    background-color: $primary-color;
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100vh;
    width: 30vw;
    max-width: 400px;
    padding: 15px;
    @media only screen and (max-width: $screen-phone-max)  {
      display:none;
    }
    &-logo {
      width: 80%;
      max-width: 200px;
      padding-bottom:25px;
    }
    &-links {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
    }
    &-link {
      text-decoration: none;
      font-size: 20px;
      font-family: $heading-font;
      color: $main-2;
      transition: .25s;
      padding-bottom: 25px;
      text-transform: uppercase;
      font-weight: 900;
      &:hover {
        color: $main-1;
        text-decoration: underline;
      }
    }
  }

  &-mobile {
    display:block;
    position:fixed;
    top: 1vh;
    z-index: 100;
    @media only screen and (min-width: $screen-phone-max)  {
      display:none;
    }
    &-link {
      background-color: black;
      display: flex;
      flex-direction: column;
    }
  }
}
</style>